import React from "react";
import { Route, Redirect } from 'react-router-dom';
import { esUsuarioAdministrativo, getUserData } from '../../utils/userAccessHelpers';

function ProfesionalRoute({ component: Component, ...rest }) {

    return <Route {...rest} render={(props) => {

        const userdata = getUserData();

        if (!userdata) {
            return <Redirect to="/" />;
        }

        if (esUsuarioAdministrativo(userdata)) {
            return (
                <Redirect
                    to={{
                        pathname: '/home',
                        state: { adminNoClinico: true }
                    }}
                />
            );
        }

        if (userdata.firma && userdata.registro) {
            return <Component {...props} />;
        }

        return (
            <Redirect
                to={{
                    pathname: '/home',
                    state: { profesionalRequisitos: true }
                }}
            />
        );
    }} />;
}

export default ProfesionalRoute;
